/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type WebhookEventState =
  typeof WebhookEventState[keyof typeof WebhookEventState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookEventState = {
  RESPONSE_RECEIVED: 'RESPONSE_RECEIVED',
  AWAITING_RESPONSE: 'AWAITING_RESPONSE',
  FAILED: 'FAILED',
} as const;
